import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const changePINReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_CHANGE_PIN:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_CHANGE_PIN_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_CHANGE_PIN_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_CHANGE_PIN:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default changePINReducer;